import md5 from 'md5';

export function useConvertMD5(text: string): string {
  const encryptedText = md5(text).toUpperCase();
  return encryptedText;
}
